import React, { useContext, useEffect, useRef, useState } from "react";
import AppContext from "../context/AppContext";

const SelectDropdown = ({
   field,
   label,
   hint,
   options,
   onChange,
   className,
   defaultOption,
   hideIfSingleOption = false,
   groupChildrenField,
}) => {
   const { registerPopupListener, popupCloseEvent } = useContext(AppContext);
   const [selectOptions, setSelectOptions] = useState(options ? options.map((i) => i) : []);
   const [initValue, setInitValue] = useState("");
   const refEl = useRef();
   useEffect(() => {
      if (options && options.length) {
         let sorted = options.sort((a, b) => {
            let fa = a.name.toLowerCase().trim(),
               fb = b.name.toLowerCase().trim();
            if (fa < fb) {
               return -1;
            }
            if (fa > fb) {
               return 1;
            }
            return 0;
         });

         if (defaultOption) {
            let found = sorted.find((o) => o.name === defaultOption.name);
            if (found) {
               sorted = sorted.filter((o) => o.name !== defaultOption.name);
               sorted.unshift({ ...found });
            }
         }
         setSelectOptions(sorted);
         setInitValue("");
         if (sorted.length === 1 || defaultOption) {
            let option = sorted[0];
            setInitValue(option.name);
            onChange && onChange({ name: field, value: option });
         }
      }
   }, [options, defaultOption, onChange, field]);
   const handleInput = (ev) => {
      let { value } = ev.target;
      setSelectOptions(() => {
         let sorted = [];
         if (groupChildrenField) {
            sorted = options
               .map((i) => {
                  let cSorted = i[groupChildrenField].filter((c) => {
                     let val = c.name;
                     return val.toLowerCase().includes(value.toLowerCase());
                  });
                  return {
                     ...i,
                     [groupChildrenField]: cSorted,
                  };
               })
               .filter((o) => o[groupChildrenField].length > 0);
         } else {
            sorted = options.filter((i) => {
               let val = i.name;
               return val.toLowerCase().includes(value.toLowerCase());
            });
         }

         if (defaultOption) {
            let found = sorted.find((o) => o.name === defaultOption.name);
            if (found) {
               sorted = sorted.filter((o) => o.name !== defaultOption.name);
               sorted.unshift({ ...found });
            }
         }
         return sorted;
      });
      console.log({ value });
      setInitValue(value);
   };
   const handleShowHide = (ev) => {
      ev.stopPropagation();
      clearPopups(ev);
      popupCloseEvent();
      refEl.current.classList.add("show");
   };
   const handleOnSelect = (ev, option) => {
      ev.preventDefault();
      ev.stopPropagation();
      clearPopups();
      setInitValue(option.name);
      onChange && onChange({ name: field, value: option });
   };
   const handleOnSelectGroup = (ev, option) => {
      ev.preventDefault();
      ev.stopPropagation();
      console.log({ ev, option });
      clearPopups();
      setInitValue(option.name);
      onChange && onChange({ name: field, value: option });
   };
   const clearPopups = () => {
      for (let d of document.querySelectorAll(".easyota-form-plugin .select-dropdown")) {
         d.classList.remove("show");
      }
   };
   useEffect(() => {
      document.addEventListener("click", () => {
         clearPopups();
      });
      registerPopupListener(() => {
         clearPopups();
      });
   }, [registerPopupListener]);
   if (hideIfSingleOption && options && options.length === 1) {
      return null;
   }

   return (
      <div className={`field ${className || ""}`}>
         <label htmlFor={field} className='pos-relative' onClick={handleShowHide}>
            {label}
            <div className='select-wrap'>
               <input
                  required
                  data-validity='0'
                  className='filtered-select'
                  type='search'
                  name={field}
                  id={field}
                  autoComplete='off'
                  placeholder={hint}
                  onInput={handleInput}
                  value={initValue}
                  onChange={() => console.log()}
               />
               <ul className='select-dropdown' ref={refEl}>
                  {selectOptions && selectOptions.length ? (
                     selectOptions.map((o, idx) => {
                        if (groupChildrenField) {
                           let groupChildren = o[groupChildrenField];
                           return (
                              <li key={idx} className='option group'>
                                 <span
                                    onClick={(ev) =>
                                       handleOnSelectGroup(ev, { ...o, group: o, isGroup: true, groupChildren })
                                    }
                                 >
                                    {o.name} ({groupChildren.length})
                                 </span>
                                 <ul>
                                    {groupChildren.map((c, idx2) => (
                                       <li
                                          key={`${idx}-${idx2}`}
                                          className='option'
                                          onClick={(ev) => handleOnSelect(ev, { ...c, group: o })}
                                       >
                                          {c.name}
                                       </li>
                                    ))}
                                 </ul>
                              </li>
                           );
                        }
                        return (
                           <li key={idx} className='option' onClick={(ev) => handleOnSelect(ev, o)}>
                              {o.name}
                           </li>
                        );
                     })
                  ) : (
                     <p className='p-1'>No record(s) found</p>
                  )}
               </ul>
            </div>
         </label>
      </div>
   );
};

export default SelectDropdown;
